import React, { useState } from 'react';
import ProductList from './components/productList';
import ProductModal from './components/productModal';
import useProductState from './hooks/useProductState';
import { message } from 'antd';

const ProductPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  
  const { products, loading, addOrUpdate, markInactive } = useProductState();

  const [modalOpen, setModalOpen] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);

  const handleAdd = () => {
    setEditingProduct(null);
    setModalOpen(true);
  };

  const handleEdit = (product) => {
    setEditingProduct(product);
    setModalOpen(true);
  };

  const handleSave = async (product) => {
    const response = await addOrUpdate(product);
    if (response?.success) {
      setModalOpen(false);
      let toastMessage = 'Product created successfully';
      if (editingProduct && editingProduct.id) {
        toastMessage = 'Product updated successfully';
      }
      messageApi.success(toastMessage, 5);
    }
    return response;
  };

  const handleDelete = async (id, date) => {
    await markInactive(id, date);
  };

  return (
    <>
      {contextHolder}
      <ProductList
        products={products}
        loading={loading}
        onEdit={handleEdit}
        markInactive={handleDelete}
        onAdd={handleAdd}
      />
      <ProductModal
        visible={modalOpen}
        onCancel={() => setModalOpen(false)}
        onSave={handleSave}
        initialData={editingProduct}
        products={products}
      />
    </>
  );
};

export default ProductPage;
